<template>
	<div class="blind">
		<p class="blind__txt">
			※ 관리자에서 표시순서만 수정 가능합니다. 신규등록, 내용수정 삭제를
			원하시는 경우 개발팀에 문의하세요.
		</p>
		<div class="blind__reason">
			<p class="blind__title">리뷰 신고사유 관리</p>
			<table class="table-main">
				<thead>
					<tr>
						<th>신고사유</th>
						<th>표시순서</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in reportTypeList" :key="item.id">
						<td>
							<input
								type="text"
								v-model="item.valueName"
								disabled
							/>
						</td>
						<td>
							<input
								type="text"
								v-model="item.seq"
								@input="
									handleInputChange('reportTypeList', item)
								"
							/>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="blind__standard">
			<p class="blind__title">블라인드 기준 관리</p>
			<table class="table-main">
				<thead>
					<tr>
						<th>블라인드 사유</th>
						<th>작성 가이드</th>
						<th>표시순서</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in blindCauseList" :key="item.id">
						<td>
							<input type="text" v-model="item.cause" disabled />
						</td>
						<td>
							<input type="text" v-model="item.guide" disabled />
						</td>
						<td>
							<input
								type="text"
								v-model="item.seq"
								@input="
									handleInputChange('blindCauseList', item)
								"
							/>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<button
			class="btn-main blue blind__modify-button"
			type="button"
			@click="handleSubmist"
		>
			수정하기
		</button>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				reportTypeList: [],
				blindCauseList: [],
				modifiedData: {
					reportTypeList: [],
					blindCauseList: [],
				},
			};
		},
		created() {
			this.getBlindCauseList();
		},
		methods: {
			async getBlindCauseList() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						'/v3/api/review/blind-settings'
					);

					this.reportTypeList = data.reportTypeList;
					this.blindCauseList = data.blindCauseList;
				} catch (e) {
					console.error(e);
				}
			},
			handleInputChange(listName, item) {
				const list = this.modifiedData[listName];
				const target = list.find(element => element.id === item.id);
				if (target) {
					target.seq = item.seq;
				} else {
					list.push({
						id: item.id,
						seq: Number(item.seq),
					});
				}
			},
			async handleSubmist() {
				try {
					await this.$axiosAdmin2.post(
						'/v3/api/review/blind-settings',
						this.modifiedData
					);
					alert('수정되었습니다.');
					this.getBlindCauseList();
				} catch (error) {
					console.error(error);
					alert(
						'수정에 실패했습니다. 지속적인 문제 발생시 개발팀에 문의해주세요.'
					);
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.blind {
		&__txt {
			font-size: 14px;
			color: $red;
			margin: 20px 0;
		}
		&__title {
			font-size: 18px;
			font-weight: bold;
			margin: 20px;
		}

		&__modify-button {
			margin: 20px auto;
			display: flex;
			justify-content: center;
			text-align: center;
		}
	}
</style>
